<main class="relative mx-auto w-full max-w-5xl pb-12 text-strong">
    <button type="button" (click)="goBack()"
            class="mb-5 inline-flex min-h-[40px] items-center gap-2 border-0 bg-transparent p-0 text-sm font-medium text-slate-600 hover:text-primary">
        <i class="bi bi-arrow-left" aria-hidden="true"></i>
        {{ isUser ? "Torna all'area riservata" : 'Indietro' }}
    </button>

    <!-- Caricamento -->
    <div *ngIf="loading" class="flex animate-pulse flex-col gap-4" role="status" aria-label="Caricamento profilo atleta">
        <div class="flex items-center gap-4 rounded-2xl border border-slate-200 bg-white p-5">
            <div class="h-16 w-16 shrink-0 rounded-xl bg-slate-200 sm:h-20 sm:w-20"></div>
            <div class="flex flex-1 flex-col gap-2">
                <div class="h-5 w-48 max-w-full rounded bg-slate-200"></div>
                <div class="h-4 w-32 rounded bg-slate-100"></div>
            </div>
        </div>
        <div class="grid gap-3 sm:grid-cols-2">
            <div *ngFor="let skeleton of [1, 2, 3, 4]" class="h-[76px] rounded-xl border border-slate-200 bg-white"></div>
        </div>
    </div>

    <ng-container *ngIf="!loading">
        <!-- Solo società: atleta in attesa di approvazione -->
        <section *ngIf="canReviewAthlete" aria-labelledby="approval-heading"
                 class="relative mb-6 flex flex-col gap-4 overflow-hidden rounded-2xl border border-slate-200 bg-white p-4 pl-5 shadow-sm sm:p-5 sm:pl-6 md:flex-row md:items-center md:justify-between">
            <span class="absolute inset-y-0 left-0 w-1 bg-amber-400" aria-hidden="true"></span>
            <div class="flex items-start gap-3">
                <span class="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-amber-50 text-lg text-amber-600">
                    <i class="bi bi-hourglass-split" aria-hidden="true"></i>
                </span>
                <div>
                    <h2 id="approval-heading" class="m-0 text-base font-bold text-strong">Atleta in attesa di approvazione</h2>
                    <p class="mb-0 mt-1 text-sm leading-6 text-slate-600">
                        Attiva il profilo per permettere l'iscrizione e il pagamento.
                        <span class="whitespace-nowrap text-slate-400">· Visibile solo alla società</span>
                    </p>
                </div>
            </div>
            <div class="flex flex-col-reverse gap-2 sm:flex-row md:shrink-0">
                <button type="button" class="btn welldone-btn-gray min-h-[44px] !px-4 !py-2 !text-sm hover:!border-red-300 hover:!text-red-600"
                        [disabled]="reviewing" (click)="rejectAthlete(athlete.id!)">
                    Disattiva profilo
                </button>
                <button type="button" class="btn btn-primary inline-flex min-h-[44px] items-center justify-center gap-2 !px-4 !py-2 !text-sm"
                        [disabled]="reviewing" (click)="approveAthlete(athlete.id!)">
                    <span *ngIf="reviewing" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                    <i *ngIf="!reviewing" class="bi bi-check-lg" aria-hidden="true"></i> Attiva profilo
                </button>
            </div>
        </section>

        <!-- Intestazione atleta -->
        <section class="mb-6 rounded-2xl border border-slate-200 bg-white p-4 sm:p-6" aria-labelledby="athlete-name">
            <div class="flex flex-col gap-5 md:flex-row md:items-center md:justify-between">
                <div class="flex min-w-0 items-center gap-4">
                    <img class="h-16 w-16 shrink-0 rounded-xl object-cover sm:h-20 sm:w-20"
                         [src]="athlete.image || 'assets/profilePic.png'"
                         [alt]="'Foto di ' + athlete.firstName + ' ' + athlete.lastName"/>
                    <div class="flex min-w-0 flex-col gap-1.5">
                        <h1 id="athlete-name" class="m-0 truncate text-xl font-bold tracking-tight text-strong sm:text-2xl">
                            {{ athlete.firstName }} {{ athlete.lastName }}
                        </h1>
                        <div class="flex flex-wrap items-center gap-2">
                            <span class="inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-xs font-semibold" [ngClass]="status.classes">
                                <i class="bi" [ngClass]="status.icon" aria-hidden="true"></i>
                                {{ status.label }}
                            </span>
                            <span *ngIf="athlete.company?.name" class="inline-flex max-w-full items-center gap-1.5 rounded-md bg-primary-soft px-2 py-1 text-xs font-semibold text-primary"
                                  title="Società di iscrizione">
                                <i class="bi bi-shield-check shrink-0" aria-hidden="true"></i><span class="truncate">{{ athlete.company?.name }}</span>
                            </span>
                            <span *ngIf="category?.name" class="inline-flex items-center gap-1.5 rounded-md bg-slate-100 px-2 py-1 text-xs font-semibold text-slate-700">
                                <i class="bi bi-tag" aria-hidden="true"></i>{{ category?.name }}
                            </span>
                        </div>
                        <span class="flex min-w-0 items-center gap-1.5 text-sm text-slate-500">
                            <i class="bi bi-envelope shrink-0" aria-hidden="true"></i>
                            <span class="truncate">{{ athlete.email || 'Nessuna email registrata' }}</span>
                        </span>
                    </div>
                </div>

                <!-- Azioni di pagamento -->
                <div class="flex flex-col gap-2 sm:flex-row md:shrink-0 md:flex-col lg:flex-row">
                    <ng-container *ngIf="canPay">
                        <a class="btn btn-primary inline-flex min-h-[44px] items-center justify-center gap-2"
                           [routerLink]="athleteCompleted() ? ['/users/payment/', athlete.id] : null"
                           [class.disabled]="!athleteCompleted()"
                           [attr.aria-disabled]="!athleteCompleted()"
                           (click)="!athleteCompleted() && $event.preventDefault()">
                            <i class="bi bi-credit-card" aria-hidden="true"></i> Procedi al pagamento
                        </a>
                    </ng-container>
                    <a *ngIf="pendingOfflinePaymentMethod as method" [routerLink]="['/iban-details']"
                       [queryParams]="method === 'transfer' ? {ibanSelected: true} : {}"
                       class="btn btn-primary inline-flex min-h-[44px] items-center justify-center gap-2">
                        <i class="bi" [ngClass]="method === 'transfer' ? 'bi-bank' : 'bi-geo-alt'" aria-hidden="true"></i>
                        {{ method === 'transfer' ? 'Dati per il bonifico' : 'Istruzioni di pagamento' }}
                    </a>
                    <a *ngIf="receiptUrl" [href]="receiptUrl" target="_blank" rel="noopener"
                       class="btn welldone-btn-light inline-flex min-h-[44px] items-center justify-center gap-2">
                        <i class="bi bi-download" aria-hidden="true"></i> Scarica ricevuta
                    </a>
                    <button *ngIf="paymentRequest?.data?.status === 'paid' && userPermission" type="button"
                            class="btn welldone-btn-danger inline-flex min-h-[44px] items-center justify-center gap-2"
                            (click)="regenerateReceipt()">
                        <i class="bi bi-arrow-repeat" aria-hidden="true"></i> Rigenera ricevuta
                    </button>
                </div>
            </div>

            <p *ngIf="canPay && !athleteCompleted()"
               class="mb-0 mt-4 flex items-start gap-2 rounded-lg bg-amber-50 px-3 py-2.5 text-sm leading-5 text-amber-800">
                <i class="bi bi-exclamation-triangle mt-0.5 shrink-0" aria-hidden="true"></i>
                <span>
                    Per procedere al pagamento completa tutte le informazioni dell'atleta (indirizzo, città, provincia, telefono ed email).
                    <a [routerLink]="['/users/edit-athlete', athlete.id]" class="font-semibold !text-amber-900 underline">Completa ora</a>
                </span>
            </p>
        </section>

        <!-- Rate del pagamento in corso (solo società) -->
        <section *ngIf="installments.length" class="mb-6 rounded-2xl border border-slate-200 bg-white p-4 sm:p-6" aria-labelledby="installments-heading">
            <div class="mb-3 flex flex-wrap items-center justify-between gap-2">
                <h2 id="installments-heading" class="m-0 text-lg font-bold text-strong">
                    Rate <span class="text-sm font-medium text-slate-500">{{ paidInstallments }} di {{ installments.length }} pagate</span>
                </h2>
                <a [routerLink]="[isSuperAdmin() ? '/admins/payment-installments' : '/companies/payment-installments', paymentRequest.data.id]"
                   class="text-sm font-semibold text-primary">Dettaglio rate <i class="bi bi-arrow-right" aria-hidden="true"></i></a>
            </div>
            <ul class="m-0 list-none divide-y divide-slate-100 p-0">
                <li *ngFor="let installment of installments" class="flex items-center gap-3 py-2.5">
                    <span class="grid h-8 w-8 shrink-0 place-items-center rounded-full text-sm font-bold"
                          [ngClass]="installment.status === 'completed' ? 'bg-emerald-50 text-emerald-700' : (installment.status === 'failed' ? 'bg-red-50 text-red-700' : 'bg-slate-100 text-slate-600')">
                        {{ installment.number }}
                    </span>
                    <span class="flex min-w-0 flex-1 flex-col">
                        <span class="text-sm font-semibold text-strong">Rata {{ installment.number }}</span>
                        <span class="text-xs text-slate-500">
                            {{ installment.status === 'completed' && installment.paidAt ? 'Pagata il ' + (installment.paidAt | date:'dd/MM/yyyy':'':'it') : 'Prevista il ' + (installment.scheduledDate | date:'dd/MM/yyyy':'':'it') }}
                        </span>
                    </span>
                    <strong class="text-sm tabular-nums text-strong">{{ installment.amount | currency:'EUR':'symbol':'1.2-2':'it' }}</strong>
                    <span class="w-28 shrink-0 rounded-md px-2 py-1 text-center text-xs font-semibold"
                          [ngClass]="installment.status === 'completed' ? 'bg-emerald-50 text-emerald-700' : (installment.status === 'failed' ? 'bg-red-50 text-red-700' : 'bg-amber-50 text-amber-800')">
                        {{ installmentStatusLabel(installment.status) }}
                    </span>
                </li>
            </ul>
        </section>

        <!-- Sezioni del profilo -->
        <section class="mb-6" aria-labelledby="sections-heading">
            <div class="mb-3 flex flex-wrap items-end justify-between gap-2">
                <h2 id="sections-heading" class="m-0 text-lg font-bold text-strong">Gestisci il profilo</h2>
                <span class="text-sm text-slate-600">
                    {{ completedSectionsCount }} di {{ trackedSections.length }} sezioni completate
                </span>
            </div>
            <div class="mb-4 h-1.5 overflow-hidden rounded-full bg-slate-200" aria-hidden="true">
                <div class="h-full rounded-full bg-primary transition-all duration-500"
                     [style.width.%]="trackedSections.length ? (completedSectionsCount / trackedSections.length) * 100 : 0"></div>
            </div>

            <div class="grid gap-3 sm:grid-cols-2">
                <a *ngFor="let section of sections; trackBy: trackSection" [routerLink]="section.route"
                   class="group flex min-h-[76px] items-center gap-3 rounded-xl border bg-white p-4 !text-strong transition hover:border-primary hover:bg-primary-soft focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                   [ngClass]="section.state === 'todo' ? 'border-amber-300' : 'border-slate-200'">
                    <span class="grid h-10 w-10 shrink-0 place-items-center rounded-lg text-lg"
                          [ngClass]="section.state === 'done' ? 'bg-emerald-50 text-emerald-700' : (section.state === 'todo' ? 'bg-amber-50 text-amber-700' : 'bg-primary-soft text-primary')">
                        <i class="bi" [ngClass]="section.icon" aria-hidden="true"></i>
                    </span>
                    <span class="flex min-w-0 flex-1 flex-col">
                        <span class="font-semibold">{{ section.title }}</span>
                        <span class="truncate text-xs text-slate-600">{{ section.description }}</span>
                    </span>
                    <span *ngIf="section.badge" class="hidden shrink-0 items-center gap-1 rounded-md px-2 py-1 text-xs font-semibold min-[400px]:inline-flex"
                          [ngClass]="section.state === 'done' ? 'bg-emerald-50 text-emerald-700' : 'bg-amber-50 text-amber-800'">
                        <i class="bi" [ngClass]="section.state === 'done' ? 'bi-check-circle' : 'bi-exclamation-circle'" aria-hidden="true"></i>
                        {{ section.badge }}
                    </span>
                    <i class="bi bi-chevron-right shrink-0 text-slate-400 transition group-hover:translate-x-0.5 group-hover:text-primary" aria-hidden="true"></i>
                </a>
            </div>
        </section>

        <!-- Riepilogo dati -->
        <section class="mb-6" aria-labelledby="summary-heading">
            <h2 id="summary-heading" class="mb-3 mt-0 text-lg font-bold text-strong">Riepilogo dati</h2>
            <div class="grid gap-3 md:grid-cols-2">
                <div class="rounded-xl border border-slate-200 bg-white">
                    <h3 class="m-0 border-0 border-b border-solid border-slate-100 px-4 py-3 text-sm font-bold text-strong">Anagrafica</h3>
                    <dl class="m-0 divide-y divide-slate-100 px-4">
                        <div class="flex justify-between gap-4 py-2.5 text-sm">
                            <dt class="font-normal text-slate-500">Data di nascita</dt>
                            <dd class="m-0 text-right font-semibold">{{ athlete.bornDate ? formatDateForTable(athlete.bornDate) : '—' }}</dd>
                        </div>
                        <div class="flex justify-between gap-4 py-2.5 text-sm">
                            <dt class="font-normal text-slate-500">Luogo di nascita</dt>
                            <dd class="m-0 text-right font-semibold">{{ athlete.bornCity || '—' }}</dd>
                        </div>
                        <div class="flex justify-between gap-4 py-2.5 text-sm">
                            <dt class="font-normal text-slate-500">Codice fiscale</dt>
                            <dd class="m-0 break-all text-right font-mono font-semibold">{{ athlete.fiscalCode || '—' }}</dd>
                        </div>
                    </dl>
                </div>

                <div class="rounded-xl border border-slate-200 bg-white">
                    <h3 class="m-0 border-0 border-b border-solid border-slate-100 px-4 py-3 text-sm font-bold text-strong">Residenza e contatti</h3>
                    <dl class="m-0 divide-y divide-slate-100 px-4">
                        <div class="flex justify-between gap-4 py-2.5 text-sm">
                            <dt class="shrink-0 font-normal text-slate-500">Indirizzo</dt>
                            <dd class="m-0 min-w-0 break-words text-right font-semibold">
                                <ng-container *ngIf="athlete.address; else missingValue">
                                    {{ athlete.address }}<span *ngIf="athlete.city">, {{ athlete.city }}</span><span *ngIf="athlete.province"> ({{ athlete.province }})</span>
                                </ng-container>
                            </dd>
                        </div>
                        <div class="flex justify-between gap-4 py-2.5 text-sm">
                            <dt class="font-normal text-slate-500">Telefono</dt>
                            <dd class="m-0 text-right font-semibold">
                                <a *ngIf="athlete.phone; else missingValue" [href]="'tel:' + athlete.phone">{{ athlete.phone }}</a>
                            </dd>
                        </div>
                        <div class="flex justify-between gap-4 py-2.5 text-sm">
                            <dt class="shrink-0 font-normal text-slate-500">Email</dt>
                            <dd class="m-0 min-w-0 break-all text-right font-semibold">{{ athlete.email || '—' }}</dd>
                        </div>
                    </dl>
                </div>

                <div *ngIf="athleteHasParents" class="rounded-xl border border-slate-200 bg-white">
                    <h3 class="m-0 border-0 border-b border-solid border-slate-100 px-4 py-3 text-sm font-bold text-strong">Genitori</h3>
                    <dl class="m-0 divide-y divide-slate-100 px-4">
                        <div *ngFor="let parent of parents; let index = index" class="flex justify-between gap-4 py-2.5 text-sm">
                            <dt class="shrink-0 font-normal text-slate-500">Genitore {{ index + 1 }}</dt>
                            <dd class="m-0 min-w-0 text-right">
                                <span class="block font-semibold">{{ parent.firstName }} {{ parent.lastName }}</span>
                                <span *ngIf="parent.address || parent.city" class="block text-xs text-slate-500">
                                    {{ parent.address }}<span *ngIf="parent.address && parent.city">, </span>{{ parent.city }}
                                </span>
                            </dd>
                        </div>
                    </dl>
                </div>

                <div *ngIf="editMemberShip" class="rounded-xl border border-slate-200 bg-white">
                    <h3 class="m-0 border-0 border-b border-solid border-slate-100 px-4 py-3 text-sm font-bold text-strong">Esperienza sportiva</h3>
                    <dl class="m-0 divide-y divide-slate-100 px-4">
                        <div class="flex justify-between gap-4 py-2.5 text-sm">
                            <dt class="font-normal text-slate-500">Prima volta sport agonistico</dt>
                            <dd class="m-0 text-right font-semibold">{{ athlete.firstTimeAgonistic == '0' ? 'No' : 'Sì' }}</dd>
                        </div>
                        <div class="flex justify-between gap-4 py-2.5 text-sm">
                            <dt class="font-normal text-slate-500">Già in questa società</dt>
                            <dd class="m-0 text-right font-semibold">{{ athlete.alreadyPlayedInCompany === 0 ? 'No' : 'Sì' }}</dd>
                        </div>
                        <div *ngIf="athlete.previousCompanyName" class="flex justify-between gap-4 py-2.5 text-sm">
                            <dt class="font-normal text-slate-500">Società precedente</dt>
                            <dd class="m-0 text-right font-semibold">{{ athlete.previousCompanyName }}</dd>
                        </div>
                    </dl>
                </div>
            </div>
        </section>

        <!-- Solo società: note -->
        <section *ngIf="editMemberShip" class="rounded-xl border border-slate-200 bg-white p-4 sm:p-5" aria-labelledby="notes-heading">
            <div class="mb-3">
                <h2 id="notes-heading" class="m-0 text-base font-bold text-strong">Note</h2>
                <p class="mb-0 mt-1 text-sm text-slate-600">Visibili solo alla società sportiva.</p>
            </div>
            <label for="athlete-notes" class="sr-only">Note sull'atleta</label>
            <textarea id="athlete-notes" [(ngModel)]="textArea" rows="6"
                      class="form-control !rounded-xl !border-slate-200 !text-base focus:!border-primary"
                      placeholder="Appunti sull'atleta…"></textarea>
            <div class="mt-3 flex justify-end">
                <button type="button" class="btn welldone-btn-light min-h-[44px] w-full sm:w-auto" (click)="saveText()">
                    <i class="bi bi-check-lg" aria-hidden="true"></i> Salva note
                </button>
            </div>
        </section>
    </ng-container>
</main>

<ng-template #missingValue><span class="font-normal text-amber-700">Da completare</span></ng-template>
